<div class="aiBox">
  <span class="pTittle">Account information</span>
  <span class="sTitle c1">CID</span>
  <span class="sTitle c2">AS account #</span>
  <span class="sTitle c3">AS account name</span>
  <span class="value c1">{{
    $safeNavigationMigration(cargoPaymentInfo?.customerID) !== undefined && cargoPaymentInfo?.customerID !== 'null'
      ? cargoPaymentInfo?.customerID
      : 'N/A'
  }}</span>
  <span class="value c2">{{
    $safeNavigationMigration(cargoPaymentInfo?.accountNumber) !== undefined ? cargoPaymentInfo?.accountNumber : 'N/A'
  }}</span>
  <span class="value c3">{{
    $safeNavigationMigration(cargoPaymentInfo?.customerName) !== undefined && cargoPaymentInfo?.customerName !== 'null'
      ? cargoPaymentInfo?.customerName
      : 'N/A'
  }}</span>
</div>
